export const PROJECT_SUPPORT_TENANT_ID = 151;
export const SUPPORT_SCOPE_PROJECT = "PROJETO";
export const SUPPORT_SCOPE_INTERNAL = "INTERNO";

const PROJECT_SUPPORT_PERMISSIONS = {
  LIST: "ROLE_Suporte_List",
  ATENDIMENTO: "ROLE_Suporte_Atendimento",
};

const INTERNAL_SUPPORT_PERMISSIONS = {
  LIST: "ROLE_SuporteInterno_List",
  ATENDIMENTO: "ROLE_SuporteInterno_Atendimento",
};

export function resolveCurrentTenant(state = {}) {
  return state?.inquilino || state?.user?.inquilino || {};
}

export function hasInternalSupport(tenant = {}) {
  const tenantId = Number(tenant?.id || 0);
  const supportTenantId = Number(tenant?.suporteMatriz || tenantId);
  if (
    tenantId === PROJECT_SUPPORT_TENANT_ID ||
    supportTenantId === PROJECT_SUPPORT_TENANT_ID
  ) {
    return false;
  }
  const modules = Array.isArray(tenant?.modulosContratacao)
    ? tenant.modulosContratacao
    : [];
  return modules.some(
    (item) => item?.tipo === "RECADOSINTERNOS" && item?.ativo !== false
  );
}

export function internalSupportLabel(tenant = {}) {
  const configuredLabel = String(tenant?.suporteBotao || "").trim();
  return configuredLabel || "Suporte interno";
}

function hasScopedPermission(state = {}, roles = {}, level = null) {
  const permissions = Array.isArray(state?.permissoes) ? state.permissoes : [];
  const normalizedLevel = String(level || "").toUpperCase();
  if (normalizedLevel && roles[normalizedLevel]) {
    return permissions.includes(roles[normalizedLevel]);
  }
  return Object.values(roles).some((role) => permissions.includes(role));
}

export function hasProjectSupportPermission(state = {}, level = null) {
  return hasScopedPermission(state, PROJECT_SUPPORT_PERMISSIONS, level);
}

export function hasInternalSupportPermission(state = {}, level = null) {
  return hasScopedPermission(state, INTERNAL_SUPPORT_PERMISSIONS, level);
}

export function resolveUserSupportContext(state = {}, requestedScope = null) {
  const tenant = resolveCurrentTenant(state);
  const internal =
    String(requestedScope || "").toUpperCase() === SUPPORT_SCOPE_INTERNAL;
  if (internal && hasInternalSupport(tenant)) {
    return {
      escopo: SUPPORT_SCOPE_INTERNAL,
      inquilinoId: Number(tenant?.suporteMatriz || tenant?.id || 0),
      label: internalSupportLabel(tenant),
    };
  }
  return {
    escopo: SUPPORT_SCOPE_PROJECT,
    inquilinoId: PROJECT_SUPPORT_TENANT_ID,
    label: "Objetivar Sistemas",
  };
}

export function resolveOperatorSupportContext(
  state = {},
  requestedScope = null
) {
  const tenant = resolveCurrentTenant(state);
  const normalizedScope = String(requestedScope || "").toUpperCase();
  const canUseProject = hasProjectSupportPermission(state);
  const canUseInternal =
    hasInternalSupportPermission(state) && hasInternalSupport(tenant);

  if (
    (normalizedScope === SUPPORT_SCOPE_INTERNAL && !canUseInternal) ||
    (normalizedScope !== SUPPORT_SCOPE_INTERNAL && canUseProject) ||
    (!canUseInternal && Number(tenant?.id) === PROJECT_SUPPORT_TENANT_ID)
  ) {
    return {
      escopo: SUPPORT_SCOPE_PROJECT,
      inquilinoId: PROJECT_SUPPORT_TENANT_ID,
      label: "Objetivar Sistemas",
    };
  }
  return {
    escopo: SUPPORT_SCOPE_INTERNAL,
    inquilinoId: Number(tenant?.suporteMatriz || tenant?.id || 0),
    label: internalSupportLabel(tenant),
  };
}
